import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/**
 * Campo de seis dígitos del segundo factor.
 *
 * `autoComplete="one-time-code"` es lo que hace que el móvil ofrezca el código
 * que acaba de llegar, y `inputMode="numeric"` abre el teclado de números sin
 * convertir el campo en `type="number"` (que se come los ceros de delante: un
 * código 012345 llegaría como 12345).
 *
 * Sólo deja escribir dígitos y recorta a seis: pegar «123 456» desde la app
 * de autenticación funciona.
 */
export const CampoCodigo = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> & {
    value: string;
    onChange: (codigo: string) => void;
    invalid?: boolean;
  }
>(({ value, onChange, invalid, className, ...props }, ref) => (
  <input
    ref={ref}
    type="text"
    inputMode="numeric"
    autoComplete="one-time-code"
    maxLength={7}
    pattern="[0-9]*"
    spellCheck={false}
    aria-invalid={invalid || undefined}
    placeholder="000000"
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
    className={cn(
      'tabular h-12 w-full rounded-lg border bg-surface px-3 text-center font-mono text-2xl tracking-[0.5em] text-fg',
      'placeholder:text-fg-subtle/50',
      invalid ? 'border-danger' : 'border-border-strong hover:border-fg-subtle',
      className,
    )}
    {...props}
  />
));
CampoCodigo.displayName = 'CampoCodigo';
